module.exports = __webpack_public_path__ + "img/tipologie-alertduedate.2811f137.png";